import Icon from '../components/Icon.vue'

Icon.register({
  'hand-rock': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M512 128.8C512 102.5 491.1 80.4 464.8 80 437.9 79.6 416 101.2 416 128H408V96.8C408 70.5 387.1 48.4 360.8 48 333.9 47.6 312 69.2 312 96V128H304V80.8C304 54.5 283.1 32.4 256.8 32 229.9 31.6 208 53.2 208 80V128H200V96.8C200 70.5 179.1 48.4 152.8 48 125.9 47.6 104 69.2 104 96V232L96 224.9V176.8C96 150.5 75.1 128.4 48.8 128 21.9 127.6 0 149.2 0 176V242.4A96-96 0 0 1 32.2 314.2L143.9 413.5A48-48 0 0 0 160 449.3V456C160 469.3 170.7 480 184 480H424C437.3 480 448 469.3 448 456V453.1A96-96 0 0 0 455.5 415.8L504.5 299.6A96-96 0 0 1 512 262.3V128.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hand-rock.js
// module id = ZycH
// module chunks = 144